import * as apiGet from 'api/carbonDioxideLabel/GetCarbonDioxideLabelIdV1';
import * as apiPost from 'api/carbonDioxideLabel/PostCarbonDioxideLabelV1';
import * as apiPut from 'api/carbonDioxideLabel/PutCarbonDioxideLabelV1';
import * as apiTranslate from 'api/translation/PostTranslationV1';
import { LocalizedTranslation } from 'types/_general/LocalizedTranslation';

export default class CarbonDioxideLabel {
	public id: string = '';
	public labelTranslations: LocalizedTranslation<string> = {};
	public maxValue: number | null = null;
	public color: string = '';

	public constructor(input?: apiGet.ResponseData) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiTranslation(fromCultureCode: string, toCultureCode: string): Promise<void> {
		const response = await apiTranslate.callApi(
			this.mapToApiTranslate(fromCultureCode, toCultureCode)
		);
		response.hasValue() && this.mapFromApiTranslate(response.get(), toCultureCode);
	}

	public async callApiPut(): Promise<void> {
		await apiPut.callApi(this.id, this.mapToApiPut());
	}

	public async callApiPost(): Promise<void> {
		const response = await apiPost.callApi(this.mapToApiPost());
		response.hasValue() && this.mapFromApiPost(response.get());
	}

	private mapToApiTranslate(
		fromCultureCode: string,
		toCultureCode: string
	): apiTranslate.Request {
		return {
			fromCultureCode: fromCultureCode,
			toCultureCode: toCultureCode,
			text: this.labelTranslations[fromCultureCode],
		};
	}

	private mapToApiPost(): apiPost.Request {
		return {
			labelTranslations: this.labelTranslations,
			maxValue: this.maxValue,
			color: this.color,
		};
	}

	private mapToApiPut(): apiPut.Request {
		return {
			labelTranslations: this.labelTranslations,
			maxValue: this.maxValue,
			color: this.color,
		};
	}

	private mapFromApi(input: apiGet.ResponseData) {
		this.id = input.id;
		this.labelTranslations = input.labelTranslations;
		this.maxValue = input.maxValue;
		this.color = input.color;
	}

	private mapFromApiPost(input: string) {
		this.id = input;
	}

	private mapFromApiTranslate(input: string, toCultureCode: string) {
		this.labelTranslations[toCultureCode] = input;
	}
}
